import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { closeLinksMiddleware } from "./middlewares";
import { linksSagas } from "./sagas";
import { LinksOverviewEngine } from "./overviewEngine";

const linksModule = (): Module => ({
	id: "linksModule",
	views: () => viewComponentProvider,
	sagas: () => linksSagas,

	middlewares: () => [closeLinksMiddleware]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	LinksOverviewEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default linksModule;
